export default "__VITE_ASSET__igNwtSTd__$_?format=webp__"